<template>
  <div class="c c-dealers">
    <DealerModule
      assets-folder="/Assets/Images/dealers"
      api-url=""
      api-key="AIzaSyAWFqcvASy-JXF3PnZFKLzOQ0KqeIOrl6k"
      translations-url="/umbraco/api/translations/getalltranslations?locale=nl-NL&dictionaryKey=Dealers"
      culture="nl-NL"
      number-of-results="5"
    >
      <template #searchButton="searchButton">
        <button
          id="searchform"
          class="btn btn-primary"
          type="button"
          @click="searchButton.search(searchButton.localSearchTerm)"
        >
          <i class="far fa-search" />
        </button>
      </template>
    </DealerModule>
  </div>
</template>

<script>
import { DealerModule } from '@frontisbv/frontisdealermodule';

export default {
    components: {
        DealerModule
    },
    props: {
        settings: {
            type: Object,
            required: true
        }
    },
    data() {
        return {};
    }
};
</script>
